import { ALERT_VARIANT } from './types';

export const SUCCESS_ALERT_BACKGROUND = '#00866B';
export const SUCCESS_ALERT_TEXT_COLOR = '#FFF';
export const ERROR_ALERT_BACKGROUND = '#F4C0B3';
export const ERROR_ALERT_TEXT_COLOR = '#3B3B3B';

export const ALERT_BACKGROUNDS = {
  [ALERT_VARIANT.SUCCESS]: SUCCESS_ALERT_BACKGROUND,
  [ALERT_VARIANT.ERROR]: ERROR_ALERT_BACKGROUND,
};

export const ALERT_TEXT_COLOR = {
  [ALERT_VARIANT.SUCCESS]: SUCCESS_ALERT_TEXT_COLOR,
  [ALERT_VARIANT.ERROR]: ERROR_ALERT_TEXT_COLOR,
};
